export default async function getDocuments() {
  const endpoint = localStorage.getItem("apiDocuments");

  /*   const header = {
    "Content-Type": " application/json",
  }; */

  const url = endpoint + "config";

  try {
    const config = { method: "GET", headers: {} };
    const response = await fetch(url, config);
    const json = await response.json();

    return json;
  } catch (error) {
    console.log("Error" + error);
  }
}
